import script from "./object_dayCollectionInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./object_dayCollectionInfo.vue?vue&type=script&setup=true&lang=js"

import "./object_dayCollectionInfo.vue?vue&type=style&index=0&id=2630a4b6&lang=css&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2630a4b6"]])

export default __exports__